// Node modules
import PropTypes from 'prop-types';
import { useState } from 'react';
import { RichText } from 'prismic-reactjs';

// Components
import Button from '@/components/global-components/Button';

// Themes
import theme from '@/themes/index';

const defaultProps = {
  moreDescription: '',
  description: '',
  imageUrl: '',
  title: '',
};

const propTypes = {
  moreDescription: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const ReadMoreCard = ({
  content: {
    description,
    image,
    title,
    moreDescription,
  }, 
}) => {

  const [readMoreExpanded, setReadMoreExpanded] = useState(false);

  return (
    <>
      <div className='container'>
        <h3 className='title'>{title}</h3>
        <img className='immersion-picture' src={image?.url} />
        <div className='description'>
          <RichText render={description} />
          {!readMoreExpanded && moreDescription &&
            <Button
              className='secondary learn-more'
              text='Read more'
              width='9.125rem'
              onClick={() => setReadMoreExpanded(true)}
              styles={{
                margin: 'auto', fontSize: '0.875rem', textAlign: 'center', maxWidth: '10rem', width: '10rem', 
              }}
            />
          }
          {
            readMoreExpanded && 
            <RichText render={moreDescription} />
          }
          {readMoreExpanded && moreDescription &&
            <Button
              className='secondary learn-more'
              text='Read less'
              width='9.125rem'
              onClick={() => setReadMoreExpanded(false)}
              styles={{
                margin: 'auto', fontSize: '0.875rem', textAlign: 'center', maxWidth: '10rem', width: '10rem', 
              }}
            />
          }
        </div>
      </div>
      <style jsx>{`
        .title {
          font-family: ${theme.fontFamilies.montserrat};
          text-align: center;
          line-height: 2rem;
          font-weight: bold;
        }
        .immersion-picture {
          width: 100%;
          height: 32rem;
          object-fit: cover;
          object-position: 0% 10%;
        }
        @media only screen and (min-width: ${theme.breakpoints.tabletMin}) {
          .title {
            line-height: 56px;
          }
        }
        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          .container {
            display: flex;
            flex-direction: column;
            width: 100%;
          }
          .title {
            font-family: ${theme.fontFamilies.openSans};
            text-align: ${moreDescription ? 'left' : 'justify'};
          }
        }
    `}</style>
      <style global jsx>{`
        div.container .description p {
          font-family: ${theme.fontFamilies.montserrat};
          line-height: 1.5rem;
          text-align: justify;
          margin: 1rem;
        }
        @media only screen and (min-width: ${theme.breakpoints.desktopMin}) {
          div.container .description p {
            font-family: ${theme.fontFamilies.openSans};
            margin: 0;
            margin-top: 1rem;
            margin-bottom: 1rem;
          }
        }
      `}</style>
    </>
  );
};

ReadMoreCard.propTypes = propTypes;
ReadMoreCard.defaultProps = defaultProps;

export default ReadMoreCard;
